<template>
  <v-container
    :class="busy ? 'fill-height' : ''"
    id="invoice-online-payment-result"
    style="width: 67%"
  >
    <v-row v-if="busy">
      <v-col class="text-center">
        <v-progress-circular
          :size="150"
          :width="6"
          class="mb-4"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <div class="display-1">
          {{ $t("message.payment_is_being_processed") }}
        </div>
      </v-col>
    </v-row>

    <v-row v-else justify="center">
      <v-col class="mt-12">
        <MaterialCardV2
          :icon="getCardIcon"
          color="primary"
          :title="getCardTitle"
        >
          <v-row class="pa-5" align="center">
            <v-col
              v-if="
                invoiceOnlinePaymentResult.external_payment_state === 'paid'
              "
            >
              <div class="display-1">
                {{ $t("label.subscription_activated") }}
              </div>
            </v-col>
            <v-col v-else>
              <div class="display-1">
                {{
                  $t("message.payment_not_processed", {
                    email: $store.state.config.email
                  })
                }}
              </div>
            </v-col>
            <v-col align="center" class="hidden-sm-and-down" cols="6">
              <v-icon size="100">{{ getCardIcon }}</v-icon>
            </v-col>
          </v-row>

          <v-divider class="mt-6"></v-divider>
          <v-row>
            <v-col>
              <v-btn
                class="no-text-transform display-1"
                color="grey darken-3"
                text
                to="/login"
              >
                {{ $t("label.return_to_login_page") }}
                <v-icon class="ml-2 lighten-5 " small>mdi-home</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </MaterialCardV2>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MaterialCardV2 from "@/components/views/MaterialCardV2.vue";
import { sleep } from "@/helpers/Sleep";

export default {
  name: "InvoiceOnlinePaymentResult",
  components: { MaterialCardV2 },
  async mounted() {
    if (!this.$store.state.subscription.payment_id) {
      await this.$router.push("/login");
      return;
    }

    const MAX_ATTEMPTS = 10;
    const MAX_DELAY = 30000;
    const MAX_DURATION = 30000;
    const DELAY_INCREASE = 500;
    let delay = 1000;
    const startTime = Date.now();

    // Delays are now 1s -> 1s -> 1.5s -> 2.5s -> 4s -> 6s -> ...
    for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
      await sleep(delay);
      delay = Math.min(delay + DELAY_INCREASE * attempt, MAX_DELAY);

      try {
        const response = await this.$store.dispatch("subscription/getResult");
        const result = response.data;

        if (
          result.external_payment_state === "paid" ||
          attempt === MAX_ATTEMPTS - 1 ||
          Date.now() - startTime > MAX_DURATION
        ) {
          this.invoiceOnlinePaymentResult = result;
          this.busy = false;
          return;
        }
      } catch {
        this.invoiceOnlinePaymentResult = { external_payment_state: "failed" };
        this.busy = false;
        return;
      }
    }
  },
  data() {
    return {
      invoiceOnlinePaymentResult: {},
      busy: true
    };
  },
  computed: {
    getCardIcon() {
      return this.invoiceOnlinePaymentResult.external_payment_state === "paid"
        ? "mdi-check"
        : "mdi-alert-circle-outline";
    },
    getCardTitle() {
      return this.invoiceOnlinePaymentResult.external_payment_state === "paid"
        ? this.$t("message.subscription_request_completed_success")
        : this.$t("message.subscription_request_completed_error");
    }
  }
};
</script>

<style scoped></style>
